import { IPost, IPostCategory, IPostPreview } from '@/interfaces/analytics'
import { IBlock } from '@/interfaces/blocks'
import { blockMapper } from '@/adapters/blocks'
import { mapImageFields } from '@/adapters/common'
import { defaultLocaleFull } from '@/shared/utils/directus'
import { mapPersonFields } from './persons'

export function mapPostCategoryFields(item: Directus.PostCategory): IPostCategory {
  const { translations, ...rest } = item
  return { ...rest, ...translations[0] }
}

export function mapPostPreviewFields(item: Directus.PostPreview, locale: string): IPostPreview {
  const imagePreview = locale === defaultLocaleFull ? item.image_preview : item.image_preview_en || item.image_preview
  const externalUrl = locale === defaultLocaleFull ? item.external_url : item.external_url_en || item.external_url

  return {
    id: item.id,
    type: item.type,
    slug: item.slug,
    external_url: externalUrl,
    date_published: item.date_published,
    category: mapPostCategoryFields(item.category),
    image_preview: mapImageFields(imagePreview),
    ...item.translations[0],
  }
}

export function mapPostFields(item: Directus.Post, locale: string): IPost {
  const previewFields = mapPostPreviewFields(item, locale)
  return {
    ...previewFields,
    authors: item.authors?.filter(i => !!i.person)?.map(i => mapPersonFields(i.person)) || [],
    blocks: (item.blocks
      ?.filter(b => !!b.item)
      ?.map((block: Directus.Block) => {
        try {
          return blockMapper.get(block.collection)?.call(null, block, locale)
        } catch (error) {
          return null
        }
      })
      ?.filter(b => !!b?.data) || []) as IBlock[],
    relevant_posts: item.relevant_posts
      ?.filter((item: Record<string, any>) => !!item.related_post)
      ?.map((item: Record<string, any>) => {
        return mapPostPreviewFields(item.related_post, locale)
      }),
  }
}
